export default __webpack_public_path__ + "images/Kampong-Tralach-Leu.webp";